import React from 'react';
import InputEasyCutImage from './inputEasyCutImage/index';

export function InputEasyImageWithProcessing(props) {
  return <InputEasyCutImage {...props} />;
}
